import styled from 'styled-components'

type Props = {
  selected?: boolean
  align?: 'left' | 'center' | 'right'
  margin?: number
}

const ButtonGroup = styled.div<Props>`
  display: flex;
  opacity: ${p => (p.selected ?? true ? 1 : 0)};
  transition: opacity 0.1s;
  justify-content: ${p =>
    !p.align || p.align === 'left'
      ? 'flex-start'
      : p.align === 'center'
      ? 'center'
      : 'flex-end'};
  & > * {
    margin-right: ${p => (p.margin ?? 1) * 4}px;
  }
  & > *:last-child {
    margin-right: 0;
  }
`

export default ButtonGroup
